// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__Fj68D","modalForm":"UpgradeEpcsModal_modalForm__3fmqu","modalFooter":"UpgradeEpcsModal_modalFooter__1GOwz"};